__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-0705d2d3/_next/";